import { Box, Button, OutlinedInput, IconButton } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { ReactNode, useEffect, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import MainContent from '../components/MainContent';
import { useNavigate } from "react-router-dom";
import { equipmentPageName } from "../components/PageName";
import { useLazyGetEquipmentListQuery, useLazyGetFileQuery, useLazyGetRealTimeTypeDDLQuery, useLazyGetEquipmentTypeDDLQuery } from "../features/equipment/EquipmentSlice";
import FormDropDownList from "../components/FormDropDownList";
import DescriptionIcon from '@mui/icons-material/Description';
import { JsxElement } from "typescript";
import { pdfIcon } from "../assets/imgs";
import SearchDropDownList from "../components/SearchDropDownList";
import RecordTableV2 from "../components/RecordTableV2";
import { RecordModel } from "../models/RecordModel";
import { useTranslation } from 'react-i18next';

const EquipmentListPage = () => {
    const [getEquipmentList, equipmentList] = useLazyGetEquipmentListQuery();
    const [getTypeDDL] = useLazyGetEquipmentTypeDDLQuery();
    const [typeDDL, setTypeDDL] = useState([{ id: 0, fullName: "" }]);
    const [getRRTDDL] = useLazyGetRealTimeTypeDDLQuery();
    const [rrtDDL, setRRTDDL] = useState([{ id: 0, name: "" }]);
    const [getFile, file] = useLazyGetFileQuery();
    const [type, setType] = useState({ id: 0, fullName: "" });
    const [rrt, setRRT] = useState({ id: 0, name: "" });
    const [rfid, setRfid] = useState("");
    const [equipmentNum, setEquipmentNum] = useState("");
    const [equipmentName, setEquipmentName] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [model, setModel] = useState("");
    const [purchaseDate, setPurchaseDate] = useState(dayjs(null));
    const [expiryDate, setExpiryDate] = useState(dayjs(null));
    const [serialNum, setSerialNum] = useState("");
    const [certDueDate, setCertDueDate] = useState(dayjs(null));
    const navigate = useNavigate();
    // const [rows, setRows] = useState([])
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const { t, i18n } = useTranslation();

    const columns: TableHeader[] = [
        { field: 'type', headerName: t("Type"), width: 150, isSortable: true },
        { field: 'rrt', headerName: t("RealTimeType"), width: 150, isSortable: true },
        // { field: 'rfid', headerName: t("RFID No."), width: 200, isSortable: false },
        { field: 'equipmentNum', headerName: t("Equipment No."), width: 200, isSortable: false },
        { field: 'equipmentName', headerName: t("Equipment Name"), width: 200, isSortable: false },
        { field: 'manufacturer', headerName: t("Brand / Manufacturer"), width: 300, isSortable: true },
        { field: 'model', headerName: t("Model No."), width: 200, isSortable: false },
        { field: 'serialNum', headerName: t("Serial No."), width: 200, isSortable: false },
        { field: 'purchaseDate', headerName: t("Purchase Date"), width: 300, isSortable: false },
        { field: 'expiryDate', headerName: t("Expiry Date"), width: 300, isSortable: false },
        { field: 'certDueDate', headerName: t("Next Cal. / Cert Due Date"), width: 200, isSortable: false },
        { field: 'calPeriod', headerName: t("Cal. Period"), width: 200, isSortable: false },
        // {
        //     field: 'certificationIcon', headerName: 'Certification', width: 200, isSortable: false,
        //     renderCell: (params: any) => {
        //         if (params?.row?.certification != null) {
        //             return (
        //                 // <IconButton onClick={() => fileUrl(params?.row?.certification)}>
        //                 //     <DescriptionIcon />
        //                 // </IconButton>
        //                 <button style={{ border: 'none', background: 'none' }} onClick={() => fileUrl(params?.row?.certification)} >
        //                     <img src={pdfIcon} />
        //                 </button>
        //             )
        //         }
        //     }
        // },
        //{ field: 'qrCode', headerName: 'QR Code', width: 200, isSortable: false },
    ];

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getEquipmentList(
            {
                EquipmentTypeId: type?.id == 0 ? null : type?.id.toString(),
                RrtTypeId: rrt?.id == 0 ? null : rrt?.id.toString(),
                // RfidNumber: rfid?.toString(),
                EquipmentNumber: equipmentNum?.toString(),
                EquipmentName: equipmentName?.toString(),
                Manufacturer: manufacturer?.toString(),
                ModelNumber: model?.toString(),
                SerialNumber: serialNum?.toString(),
                PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
                ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
                CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                equipmentId: item.id,
                type: item.equipmentTypeName,
                rrt: item.rrtName,
                // rfid: item.rfidNumber,
                equipmentNum: item.equipmentNumber,
                equipmentName: item.equipmentName,
                manufacturer: item.manufacturer,
                model: item.modelNumber,
                serialNum: item.serialNumber,
                purchaseDate: item.purchaseDate,
                expiryDate: item.expiryDate,
                certDueDate: item.certDueDate,
                calPeriod: "N/A",
                certification: item.certificationFileId,
            }))
        }
        // return [];
    };

    const fileUrl = (Id: string) => {
        getFile(Id).then((res) => {
            console.log(res);
            if (res?.data != undefined) {
                const link = document.createElement('a');
                link.href = res?.data?.url;
                link.click();
            }
        })
    }

    const handleDDLonChange = (name: string) => {
        const matchType = typeDDL?.find((item: any) => item?.fullName === name);
        if (matchType != undefined) {
            setType(matchType);
        }
    }

    const handleRRTDDLonChange = (name: string) => {
        const matchType = rrtDDL?.find((item: any) => item?.name === name);
        if (matchType != undefined) {
            setRRT(matchType);
        }
    }

    const handleSearchClick = async () => {
        try {
            getEquipmentList({
                EquipmentTypeId: type?.id == 0 ? null : type?.id.toString(),
                RrtTypeId: rrt?.id == 0 ? null : rrt?.id.toString(),
                RfidNumber: rfid?.toString(),
                EquipmentNumber: equipmentNum?.toString(),
                EquipmentName: equipmentName?.toString(),
                Manufacturer: manufacturer?.toString(),
                ModelNumber: model?.toString(),
                SerialNumber: serialNum?.toString(),
                PurchaseDate: purchaseDate?.format("DD/MM/YYYY").toString(),
                ExpiryDate: expiryDate?.format("DD/MM/YYYY").toString(),
                CertDueDate: certDueDate?.format("DD/MM/YYYY").toString(),
            }).then(
                (res) => {
                    if (res.status == 'fulfilled') {

                        const tableRows = res?.data.records.map((item: any) => ({
                            id: item?.id,
                            equipmentId: item.id,
                            type: item.equipmentTypeName,
                            rrt: item.rrtName,
                            rfid: item.rfidNumber,
                            equipmentNum: item.equipmentNumber,
                            equipmentName: item.equipmentName,
                            manufacturer: item.manufacturer,
                            model: item.modelNumber,
                            serialNum: item.serialNumber,
                            purchaseDate: item.purchaseDate,
                            expiryDate: item.expiryDate,
                            certDueDate: item.certDueDate,
                            calPeriod: "N/A",
                            certification: item.certificationFileId,
                        }))
                        setTableRows(tableRows)
                        setData(res?.data)
                    }
                }
            )
            // .then((respone: any) => respone?.data?.records)
            //     .then((d: any) => {
            //         console.log(d);
            //         setRows(d.map((item: { id: any; equipmentTypeId: any; rfidNumber: any; equipmentNumber: any; modelNumber: any; manufacturer: any; serialNumber: any; purchaseDate: any; expiryDate: any; certDueDate: any; equipmentName: any; certificationFileId: any; }) => {
            //             return {
            //                 equipmentId: item.id,
            //                 type: item.equipmentTypeId,
            //                 rfid: item.rfidNumber,
            //                 equipmentNum: item.equipmentNumber,
            //                 equipmentName: item.equipmentName,
            //                 manufacturer: item.manufacturer,
            //                 model: item.modelNumber,
            //                 purchaseDate: item.purchaseDate,
            //                 expiryDate: item.expiryDate,
            //                 certDueDate: item.certDueDate,
            //                 calPeriod: "N/A",
            //                 certification: item.certificationFileId,
            //             };
            //         }))
            //     })
        } catch (error) {

        }
    }
    useEffect(() => { console.log("data", data) }, [data])
    useEffect(() => {
        handleSearchClick();
        getTypeDDL().then((res) => {
            if (res.status == 'fulfilled') {
                let ddl = [{ id: 0, fullName: "ALL" }, ...res.data];
                console.log(ddl);
                setTypeDDL(ddl);
            }
        });
        getRRTDDL().then((res) => {
            if (res.status == 'fulfilled') {
                let ddl = [{ id: 0, name: "ALL" }, ...res.data];
                setRRTDDL(ddl);
            }
        });
    }, [])

    const handleRowClick = (equipment: any, field?: string) => {
        //console.log(field)
        // Handle the row click event and pass the row value to another page or component
        if (field != undefined && (field == 'certificationIcon' || field == '__check__')) {
            //console.log("Icon Button Click")
        }
        else {
            //console.log(equipment?.equipmentId);
            navigate('/equipment-detail', { state: equipment?.equipmentId });
        }

    };

    return (
        <MainContent type={equipmentPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Equipment")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                {/* <FormDropDownList sameRowTitle={"Type"} value={type} handleValueChange={(event: any) => setType(event?.target?.value)} items={tempType.map(item => item.name)} /> */}
                                <SearchDropDownList title={(t("Type"))} value={type?.fullName} handleValueChange={(event: any) => handleDDLonChange(event?.target?.value)} items={typeDDL?.map((item: { fullName: any; }) => item.fullName)} />
                                <SearchDropDownList title={t("RealTimeType")} value={rrt?.name} handleValueChange={(event: any) => handleRRTDDLonChange(event?.target?.value)} items={rrtDDL?.map((item: { name: any; }) => item.name)} />
                                {/* <SearchInput title={t("RFID No.")} value={rfid} setMethod={setRfid} /> */}
                                <SearchInput title={t("Equipment No.")} value={equipmentNum} setMethod={setEquipmentNum} />
                                <SearchInput title={t("Equipment Name")} value={equipmentName} setMethod={setEquipmentName} />
                                <SearchInput title={t("Manufacturer")} value={manufacturer} setMethod={setManufacturer} />
                                <SearchInput title={t("Model")} value={model} setMethod={setModel} />
                                <SearchDatePicker title={t("Purchase Date")} value={purchaseDate} setMethod={setPurchaseDate} />
                                <SearchDatePicker title={t("Expiry Date")} value={expiryDate} setMethod={setExpiryDate} />
                                <SearchInput title={t("Serial No.")} value={serialNum} setMethod={setSerialNum} />
                                <SearchDatePicker title={t("Cert Due Date")} value={certDueDate} setMethod={setCertDueDate} />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={handleSearchClick}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={() => { navigate('/add-equipment') }}>{t("Add New Equipment")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* <RecordTable getRowId={e => e.equipmentId} columns={columns} rows={rows} checkbox={true} onClick={handleRowClick}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};
export default EquipmentListPage;